import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIcon$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIcon extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '92fdc5d3b29d350397cb23a611ca595a05f20a02', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("slot", { key: '4e789f7608c442c8ea0aa9e7d7fdf94da1d70fcf' })));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIcon$1);
            }
            break;
    } });
}

const CosmosIcon = CosmosIcon$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIcon, defineCustomElement };
